import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

export type MessageType = 'success' | 'error' | 'info' | 'warning'

export interface MessageModalData {
  type: MessageType
  title?: string
  message: string
}

const ICON: Record<MessageType, string> = {
  success: '✓',
  error: '!',
  warning: '!',
  info: 'i',
}

const ICON_STYLE: Record<MessageType, string> = {
  success: 'bg-success/15 text-success',
  error: 'bg-destructive/15 text-destructive',
  warning: 'bg-warning/15 text-warning',
  info: 'bg-primary/15 text-primary',
}

/**
 * Temalı, ortalanmış mesaj modalı — native alert() yerine kullanılır.
 * CLAUDE.md kuralı: overlay'e tıklayarak kapatma YOK; yalnızca buton/X ile kapanır.
 */
export function MessageModal({ data, onClose }: { data: MessageModalData | null; onClose: () => void }) {
  const { t } = useTranslation('common')
  if (!data) return null

  const title = data.title ?? t(`messageModal.${data.type}`, { defaultValue: '' })

  return createPortal(
    <div className="modal-overlay">
      <div className="modal-box max-w-md">
        <div className="p-6 flex flex-col items-center text-center gap-4">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl font-bold ${ICON_STYLE[data.type]}`}>
            {ICON[data.type]}
          </div>
          {title && <h2 className="text-base font-semibold text-foreground">{title}</h2>}
          <p className="text-sm text-muted-foreground whitespace-pre-line">{data.message}</p>
          <button onClick={onClose} className="btn-primary text-sm mt-2 min-w-24">
            {t('messageModal.ok', { defaultValue: 'Tamam' })}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}

export default MessageModal
